define.alias("shared/components/shared/post-tagging/color-circle", "media/components/shared/post-tagging/color-circle");